import styled from '@xstyled/styled-components';
import Speaker from '~/training/onboarding/assets/speaker.svg';

export const SpeakerIcon = styled(Speaker)`
  max-width: 33px;
  max-height: 33px;
  fill: black;
  width: 33px;
  height: 33px;
`;
